<div class="comment-container">
  <div class="asset-comments" #assetActivity>
    <ng-template #loadingComments>
      <div class="no-comments">
        <span>{{ 'loading' | translate }}...</span>
      </div>
    </ng-template>

    <ng-container *ngIf="comments$ | async as data; else loadingComments">
      <div *ngIf="!data.days.length" class="no-comments">
        <app-svg src="/assets/icons/64/comments.svg"></app-svg>
        <span>{{ 'no-comments-text' | translate }}</span>
      </div>

      <div class="comment-day" *ngFor="let day of data.days">
        <div class="comment-date">
          {{ day.date }}
        </div>
        <div class="comment-items">
          <ng-container *ngFor="let comment of day.comments; let i = index">
            <div
              class="comment-item"
              *ngIf="comment.type === 'normal'"
              [class.not-last-of-group]="!comment.isLastOfGroup"
              [class.own]="comment.authorId === myId"
            >
              <ng-template #authorPlaceholder>
                <div class="profile-icon"></div>
              </ng-template>
              <ng-container
                *ngIf="comment.isLastOfGroup && comment.author | avatar | async as avatarSrc; else authorPlaceholder"
              >
                <a
                  [routerLink]="['/a/settings/people/', comment.authorType, comment.authorId]"
                  appTooltip="View profile"
                  *ngIf="comment.authorId !== myId && accessLevel === 'edit'"
                  class="profile-icon"
                  [style.background-image]="'url(' + avatarSrc + ')'"
                >
                </a>
                <div
                  class="profile-icon"
                  *ngIf="comment.authorId === myId || accessLevel !== 'edit'"
                  [style.background-image]="'url(' + avatarSrc + ')'"
                ></div>
              </ng-container>

              <div
                class="message"
                [appTooltip]="editing === comment ? undefined : (comment.createdDate | date : 'HH:mm')"
                [class.active]="activeAnnotation && activeAnnotation?.commentId === comment.id"
              >
                <div
                  class="message-author"
                  [style.color]="comment.author | userColor | async"
                  [class.has-annotation]="comment.annotation"
                  *ngIf="comment.authorId !== myId && comment.isFirstOfGroup"
                >
                  {{ comment.name }}
                </div>
                <ng-container *ngIf="editing !== comment">
                  <span *ngIf="!comment.annotation" [innerHTML]="comment.text"></span>
                  <div *ngIf="!!comment.annotation" (click)="viewAnnotation(comment)" class="comment-annotation">
                    <img src="/assets/Annotation-Color.png" *ngIf="activeAnnotation?.commentId !== comment.id" alt="" />
                    <img
                      src="/assets/Annotation-Color-dark.png"
                      *ngIf="activeAnnotation?.commentId === comment.id"
                      alt=""
                    />
                    <span>{{ 'annotation' | translate }}</span>
                    <app-svg *ngIf="activeAnnotation?.commentId !== comment.id" src="/assets/icons/eye-open.svg">
                    </app-svg>
                    <app-svg
                      *ngIf="activeAnnotation?.commentId === comment.id"
                      src="/assets/icons/eye-strikethrough.svg"
                      class="hide-annotation"
                    >
                    </app-svg>
                  </div>
                </ng-container>
                <div class="editting" *ngIf="editing === comment">
                  <div
                    class="comment textarea"
                    name="edit-comment"
                    contenteditable
                    [(wysiwyg)]="comment.text"
                    [allowHtml]="true"
                  ></div>
                  <div class="edit-comment-actions">
                    <div (click)="cancelEditing()" class="comment-edit-action cancel">{{ 'cancel' | translate }}</div>
                    <div (click)="saveEditing()" class="comment-edit-action save">{{ 'save' | translate }}</div>
                  </div>
                </div>
              </div>
              <span class="sending" *ngIf="!comment.id">
                <app-loading-indicator [size]="'smaller'" [color]="'grey-50'"></app-loading-indicator>
              </span>
              <div class="message-interactions" *ngIf="comment.id && comment.id !== 'extra'">
                <app-context-menu
                  [options]="{ width: '220px', noSpacing: true }"
                  [position]="'right'"
                  name="comment-actions"
                  #menu2
                  *ngIf="comment.authorId === myId || accessLevel === 'edit'"
                >
                  <button
                    appButton
                    name="comment-actions"
                    location="asset-comments"
                    [iconButton]="true"
                    color="simple"
                    shape="round"
                    class="comment-actions-button"
                    contextButton
                  >
                    <app-svg src="/assets/icons/dots-vertical.svg"></app-svg>
                  </button>
                  <div contextContent class="comment-action-menu">
                    <div class="button-menu">
                      <ng-container *ngIf="comment.authorId === myId && comment.text">
                        <app-button-menu-item
                          name="edit-comment"
                          location="asset-comments"
                          (click)="editComment(comment); menu2.close()"
                          [fullWidth]="true"
                          >{{ 'edit' | translate }}
                        </app-button-menu-item>
                        <div class="divider"></div>
                      </ng-container>
                      <app-button-menu-item
                        name="delete-comment"
                        location="asset-comments"
                        color="simple-warn"
                        (click)="deleteComment(comment); menu2.close()"
                        [fullWidth]="true"
                        >{{ 'delete' | translate }}
                      </app-button-menu-item>
                    </div>
                  </div>
                </app-context-menu>
              </div>
            </div>
            <div
              *ngIf="comment.type === 'meta'"
              class="comment-item"
              [class.not-last-of-group]="!comment.isLastOfGroup"
              appTooltip="{{ comment.createdDate | date : 'HH:mm' }}"
            >
              <span class="meta-text">
                <b *ngIf="comment.authorId !== myId">
                  <a
                    [routerLink]="['/a/settings/people/', comment.authorType, comment.authorId]"
                    *ngIf="accessLevel === 'edit'"
                    appTooltip="View Profile"
                    >{{ comment.name }}</a
                  >
                  <span *ngIf="accessLevel !== 'edit'" appTooltip="View Profile">{{ comment.name }}</span>
                </b>
                <b *ngIf="comment.authorId === myId">{{ 'you' | translate }}</b> {{ comment.text }}</span
              >
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="chat-box" *ngIf="allowedAndEnabledFeedbackOptions.includes('comment')">
    <div class="chat-top" [class.focused]="messageFocused">
      <div class="message-input">
        <div
          class="profile-icon"
          *ngIf="user || guest | avatar | async as avatarSrc"
          [style.background-image]="'url(' + avatarSrc + ')'"
        ></div>

        <div class="textarea-container">
          <div
            class="textarea"
            name="comment"
            contenteditable
            [(wysiwyg)]="message"
            [allowHtml]="true"
            #commentField
            (focus)="messageFocused = true"
            (blur)="messageFocused = false"
          ></div>
        </div>
        <div class="placeholder" *ngIf="!message.length">{{ 'add-a-comment' | translate }}...</div>

        <div class="message-actions">
          <app-context-menu
            [options]="{ width: '360px', noSpacing: true }"
            class="emoji-toggle"
            *onlyForScreens="['desktop']"
          >
            <button
              appButton
              name="add-emoji"
              location="asset-comments"
              [iconButton]="true"
              color="simple"
              height="0"
              appTooltip="Add emojis"
              contextButton
              shape="round"
            >
              <app-svg src="/assets/icons/smiley-outline.svg"></app-svg>
            </button>

            <div contextContent>
              <ng-template #emojiselectortemp></ng-template>
            </div>
          </app-context-menu>
        </div>
      </div>
    </div>

    <div class="chat-bottom">
      <app-context-menu
        [options]="{ width: '300px', openOnHover: true }"
        class="notification-info-container"
        [class.no-watchers]="!watchers?.length"
        #watcherMenu
      >
        <div class="notification-info" contextButton>
          <div class="notification-info-icons">
            <ng-container *ngFor="let watcher of watchers | slice : 0 : 5">
              <div
                class="avatar"
                *ngIf="watcher | avatar | async as avatarSrc"
                [style.background-image]="'url(' + avatarSrc + ')'"
              ></div>
            </ng-container>
          </div>
          <div
            class="notification-info-text"
            *ngIf="watchers?.length"
            [innerHtml]="
              (watchers.length === 1 ? 'one-person-will-be-notified' : 'x-people-will-be-notified')
                | translate : [{ key: 'XX', value: watchers.length.toString() }]
            "
          >
            <!-- <b>{{watchers.length}} <span *ngIf="watchers.length === 1">Person</span><span
              *ngIf="watchers.length > 1">People</span></b> will be notified -->
          </div>
          <div
            class="notification-info-text"
            *ngIf="!watchers?.length"
            [innerHtml]="'no-one-will-be-notified' | translate"
          ></div>
        </div>
        <div contextContent>
          <ng-container *ngIf="watcherMenu.isOpen">
            <div *ngFor="let watcher of watchers" class="watcher-details">
              <div
                class="avatar"
                *ngIf="watcher | avatar | async as avatarSrc"
                [style.background-image]="'url(' + avatarSrc + ')'"
              ></div>
              <span>{{ watcher.first_name }} {{ watcher.last_name }}</span>
            </div>
          </ng-container>
        </div>
      </app-context-menu>
      <button
        appButton
        name="send"
        location="asset-comments"
        color="primary"
        [class.disabled]="sending || !message"
        height="1"
        spacing="3"
        (click)="submitMessage()"
        data-test-id="comment"
      >
        {{ 'send' | translate }}
      </button>
    </div>
  </div>
</div>

<button *ngIf="featureFlags.get('websocketTest')" (click)="testWebsocketMessages()" class="test-websockets-button">
  Test websocket messages
</button>
